import { useOuraData } from "../contexts/OuraDataContext";

/**
 * WHAT:
 *   Optimized Activity Hook using centralized data context.
 *
 * WHY:
 *   Uses centralized data context instead of making separate API calls.
 *
 * @returns Object containing activity data, error, loading state, score, and steps
 *
 */
export const useOptimizedActivity = () => {
  const { activity, error, loading } = useOuraData();

  return {
    activity,
    error,
    loading,
    score: activity?.score ?? 0,
    steps: activity?.steps ?? 0,
  };
};
